"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_camera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f42acd0c-98bb-40c8-b6c7-8cb5815f93f5",
    x1: 97.05,
    y1: 106.38,
    x2: 162.64,
    y2: 171.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "camera-hi"), /*#__PURE__*/React.createElement("g", {
    id: "35c503d8-30f1-457d-86dd-7333d894a65a",
    "data-name": "camera-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6f89ebc7-6075-4b0c-ab20-f8879274fa90",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5b6cb5a5-5c54-4a18-a887-a6c1cbfe1e95",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2bef7a08-edd9-4187-9b94-9538c8f3d048",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "21079717-5efb-457b-a232-2cdf4e89290f",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14b61625-e130-4eeb-ae38-3bcea40d344d",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5f415676-91fd-49fe-84f3-295e45893834",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e3a4e8c4-0de9-4e65-a97c-3a2437cebd01",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5ec73c36-0ac2-4b93-a6ad-f2f21dff7bdc",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,168H32a16,16,0,0,1-16-16V64a8,8,0,0,1,8-8H42a12,12,0,0,0,9.6-4.8L68.4,28.8A12,12,0,0,1,78,24h36a12,12,0,0,1,9.6,4.8l16.8,22.4A12,12,0,0,0,150,56h18a8,8,0,0,1,8,8v88A16,16,0,0,1,160,168Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176,120v32a16,16,0,0,1-16,16H94L64.38,139.05,129.43,74Z",
    transform: "translate(0 0)",
    fill: "url(#f42acd0c-98bb-40c8-b6c7-8cb5815f93f5)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 106,
    r: 46,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 106,
    r: 32,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,150a46,46,0,0,1-46-45c0,.33,0,.66,0,1a46,46,0,0,0,92,0c0-.34,0-.67,0-1A46,46,0,0,1,96,150Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 106,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 74,
    r: 6,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,94c0,9.66-12.54,17.5-28,17.5S68,103.67,68,94,80.54,74,96,74,124,84.34,124,94Z",
    transform: "translate(0 0)",
    fill: "#ebebeb",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 98,
    r: 4,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,166H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-2A16,16,0,0,1,160,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4,51.2,123.6,28.8A12,12,0,0,0,114,24H78a12,12,0,0,0-9.6,4.8L51.6,51.2A12,12,0,0,1,42,56H150A12,12,0,0,1,140.4,51.2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  })))))))))));
}

var _default = ic_camera;
exports.default = _default;